import { defineAction } from '~/prix'
import { z } from 'zod'
import machineServiceImageUpdateAction from './machineServiceImageUpdate.action.json' with { type: 'json' }
import { machineServiceImageUpdateInputObject } from '../machineServiceImageObject'

const machineServiceImageUpdateDefinition = defineAction({
  ...machineServiceImageUpdateAction,

  input: machineServiceImageUpdateInputObject,
  output: z.object({}),
})

export default machineServiceImageUpdateDefinition
